export class SelectHarnessController {
  public selection: any;
  public selectionText: any;
  public options1: string[];
  public options2: string[];
  public caseStates: any[];
  public selectedCaseState: any;
  public selectedCaseStateUsingPredicate: any;
  constructor() {
    this.options1 = ["just", "select", "one", "of", "these"];
    this.selectionText = "select";
    this.options2 = [
      "just",
      "select",
      "one",
      "of",
      "these",
      "super long option... 0123456789  0123456789 0123456789 0123456789 0123456789 0123456789 0123456789"
    ];
    this.caseStates = [
      { text: "open", value: "openValue" },
      { text: "closed", value: "closedValue" }
    ];
    this.selectedCaseState = this.caseStates[0];
    this.selectedCaseStateUsingPredicate = this.caseStates[1];
  }

  public onChange(value: any) {
    console.log("changed to " + value);
  }

  public checkForEquality(option: any, selectedItem: any) {
    return option.value == selectedItem.value;
  }

  public checkForEqualityPredicate = `public checkForEquality(option: any, selectedItem: any) {
        \t return option.value == selectedItem.value;
    }`;
}
